import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './pages/Layout/Layout';
import PasswordResetRequest from './pages/PasswordResetRequest/PasswordResetRequest';
import PasswordRenew from './pages/PasswordRenew/PasswordRenew';
import PasswordResetRequestSuccess from './pages/PasswordResetRequest/PasswordResetRequestSuccess/PasswordResetRequestSuccess';
import PasswordRenewSuccess from './pages/PasswordRenew/PasswordRenewSuccess/PasswordRenewSuccess';
import PasswordRenewError from './pages/PasswordRenew/PasswordRenewError/PasswordRenewError';
import PasswordResetRequestError from './pages/PasswordResetRequest/PasswordResetRequestError/PasswordResetRequestError';
import { useTealiumTracking } from './trackingService';
import ServiceUnavailable from './pages/ServiceUnavailable/ServiceUnavailable';
import './App.scss';

const App = () => {
  const { setTrackingObject } = useTealiumTracking();

  const [isPasswordResetEmailUiDisabled, setIsPasswordResetEmailUiDisabled] =
    useState<boolean | undefined>(undefined);

  useEffect(() => {
    fetchEmailResetDisabledFeatureToken()
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error('Network response was not ok.');
      })
      .then((data) => {
        setIsPasswordResetEmailUiDisabled(data.enabled);
      })
      .catch(() => {
        setIsPasswordResetEmailUiDisabled(true);
      });
  });

  if (isPasswordResetEmailUiDisabled === undefined) {
    return null;
  }

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <>
          {isPasswordResetEmailUiDisabled === true ? (
            <Route path="/" element={<Layout />}>
              <Route index element={<ServiceUnavailable />} />
            </Route>
          ) : (
            <Route path="/" element={<Layout />}>
              <Route
                index
                element={
                  <PasswordResetRequest setTrackingObject={setTrackingObject} />
                }
              />
              <Route path="error" element={<PasswordResetRequestError />} />
              <Route path="unavailable" element={<ServiceUnavailable />} />
              <Route path="success" element={<PasswordResetRequestSuccess />} />
              <Route path="*" element={<PasswordResetRequestError />} />
            </Route>
          )}
          <Route path="neues-passwort-vergeben" element={<Layout />}>
            <Route
              index
              element={<PasswordRenew setTrackingObject={setTrackingObject} />}
            />
            <Route path="error" element={<PasswordRenewError />} />
            <Route path="success" element={<PasswordRenewSuccess />} />
            <Route path="*" element={<PasswordRenewError />} />
          </Route>
        </>
      </Routes>
    </BrowserRouter>
  );
};

const fetchEmailResetDisabledFeatureToken = async () => {
  return fetch(
    `${process.env.REACT_APP_HOST_URL}/unleash-edge/api/client/features/PasswordResetEmailUiDisabled`,
    {
      headers: {
        Authorization: process.env.REACT_APP_UNLEASH_TOKEN ?? '',
      },
    },
  );
};

export default App;
